export const config_url = `https://backend.werkeninmarokko.be`;
